import { AssetCatalog, AudioPlayer, defaultMixer, parseMixer, type MixerState } from '@ddt/game-engine';
import { ref } from 'vue';
import { getServices } from './services';

const MUTE_KEY = 'ddt.audio.muted';
const MIXER_KEY = 'ddt.audio.mixer';

function readMuted(): boolean {
  try {
    return localStorage.getItem(MUTE_KEY) === '1';
  } catch {
    return false;
  }
}

/** Som desligado pelo jogador (guardado no navegador). Vale para música e efeitos. */
export const muted = ref(readMuted());

function readMixer(): MixerState {
  try {
    const raw = localStorage.getItem(MIXER_KEY);
    return parseMixer(raw ? JSON.parse(raw) : null);
  } catch {
    return defaultMixer();
  }
}

/** O player único do app: a música do lobby, da sala e da partida e os efeitos passam por ele (com o mixer que o jogador guardou). */
export const audio = new AudioPlayer({ muted: muted.value, mixer: readMixer() });

/** Estado do mixer para a interface (volume geral e de cada categoria); acompanha o player e é guardado no navegador a cada mudança. */
export const mixer = ref<MixerState>(audio.getMixer());
/** Janela do mixer aberta (o botão fica no cabeçalho e também na partida). */
export const mixerOpen = ref(false);

audio.subscribe((next) => {
  mixer.value = next;
  try {
    localStorage.setItem(MIXER_KEY, JSON.stringify(next));
  } catch {
    // sem armazenamento: vale só nesta sessão
  }
});

/** Volta todas as barras ao padrão. */
export function resetMixer(): void {
  audio.setMixer(defaultMixer());
}

export function toggleMute(): void {
  muted.value = !muted.value;
  audio.setMuted(muted.value);
  try {
    localStorage.setItem(MUTE_KEY, muted.value ? '1' : '0');
  } catch {
    // sem armazenamento: vale só nesta sessão
  }
}

let catalog: Promise<AssetCatalog> | null = null;

/** O manifest de assets, baixado uma vez; quem chega depois recebe a mesma promessa. Se falhar, a próxima chamada tenta de novo. */
export function assetCatalog(): Promise<AssetCatalog> {
  if (!catalog) {
    const loading = AssetCatalog.load(getServices().platform.env.assetsUrl);
    catalog = loading;
    loading.then((loaded) => audio.setAssets(loaded)).catch(() => (catalog = null));
  }
  return catalog;
}
